module.exports = __webpack_public_path__ + "img/1.-东岳庙状元槐（赵晴-摄）.ad159b98.jpg";